/* CELLFIE proportional scale.

   Below the reference width the page keeps its full size layout and is scaled
   down to fit, so nothing reflows and nothing gets cropped.

   The zoom goes on .page-wrapper, not on body. That matters: the cart drawer,
   the search modal, the quick add dialog and the buy sheet are all siblings of
   .page-wrapper inside body, so putting the zoom one level lower leaves every
   overlay outside the scaled subtree by construction.

   The previous version zoomed body and then measured each overlay to work out
   how much zoom to cancel. That measurement is wrong in WebKit, where
   getBoundingClientRect ignores zoom completely: a 400px box inside a zoom 0.5
   parent still reports 400. So Safari always measured 'no zoom applied',
   cancelled nothing, and the drawer rendered at a fraction of its size with
   9px text. Nothing here measures anything any more. */
(function () {
  var REF = 1440;
  var FLOOR = 480;

  var root = document.documentElement;
  if (!('zoom' in root.style)) return;

  var sheet = document.getElementById('cf-scale-style');
  if (!sheet) {
    sheet = document.createElement('style');
    sheet.id = 'cf-scale-style';
    (document.head || root).appendChild(sheet);
  }

  var lastKey = null;

  function apply() {
    var w = window.innerWidth;
    var z = 1;

    if (w >= FLOOR && w < REF) z = w / REF;
    z = Math.round(z * 10000) / 10000;

    if (z === lastKey) return;
    lastKey = z;

    if (z === 1) {
      sheet.textContent = '';
      root.classList.remove('cf-scaled');
      return;
    }

    sheet.textContent =
      'html{overflow-x:hidden;}' +
      'body{width:auto;}' +
      'html.cf-scaled .page-wrapper{width:' + REF + 'px;zoom:' + z + ';height:auto !important;min-height:0 !important;overflow:visible !important;}' +
      'html.cf-scaled{--cf-z:' + z + ';--cf-vw:' + (REF / 100) + 'px;}' +
      'html.cf-scaled .footer-content{grid-auto-flow:column !important;grid-template-columns:none !important;grid-auto-columns:minmax(0,1fr) !important;}' +
      'html.cf-scaled .utilities{display:grid !important;grid-auto-flow:column !important;grid-auto-columns:minmax(0,1fr) !important;align-items:center !important;}' +
      'html.cf-scaled .footer-utilities__group-copyright,html.cf-scaled .footer-utilities__text{text-align:start !important;}' +
      'html.cf-scaled .social-icons__wrapper{flex-wrap:nowrap !important;}' +
      'html.cf-scaled .social-icons__icon-wrapper{text-align:end !important;}';

    root.classList.add('cf-scaled');
  }

  apply();

  var pending = null;
  function queue() {
    window.clearTimeout(pending);
    pending = window.setTimeout(apply, 40);
  }

  window.addEventListener('resize', queue, { passive: true });
  window.addEventListener('orientationchange', queue);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply);
  }
})();